import { render, staticRenderFns } from "./rewardCrazyBet.vue?vue&type=template&id=657c885d&scoped=true&"
import script from "./rewardCrazyBet.vue?vue&type=script&lang=js&"
export * from "./rewardCrazyBet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c885d",
  null
  
)

export default component.exports